import React from 'react';
import { useNavigate } from 'react-router-dom';

const Services = () => {
  const navigate = useNavigate();
  const services = [
    {
      title: "Staff Recruitment",
      description: "We source the right candidate by exploiting our private database, personal network, and job portals.",
      icon: "👥",
      features: ["Sourcing", "Screening", "Shortlisting", "Selection"],
      path: "/services/staff-recruitment"
    },
    {
      title: "Staffing",
      description: "Providing flexible staffing solutions to meet your temporary and permanent hiring needs.",
      icon: "🏗️",
      features: ["Temporary Staffing", "Permanent Staffing", "Contract Staffing", "Project-based Staffing"],
      path: "/services/staffing"
    },
    {
      title: "Training",
      description: "Comprehensive training programs to enhance the skills and productivity of your workforce.",
      icon: "👨‍🏫",
      features: ["Skill Development", "Corporate Training", "Soft Skills", "Technical Training"],
      path: "/services/training"
    },
    {
      title: "Resume Building",
      description: "Professional resume building services to help candidates stand out in the job market.",
      icon: "📄",
      features: ["Resume Writing", "Cover Letter", "LinkedIn Profile", "Portfolio Creation"],
      path: "/services/resume-building"
    },
    {
      title: "Interview Preparation",
      description: "Expert guidance and mock interviews to prepare candidates for their dream job interviews.",
      icon: "🎙️",
      features: ["Mock Interviews", "Body Language", "Common Questions", "Confidence Building"],
      path: "/services/interview-preparation"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50" data-aos="fade-up">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-4">
          Our Services
        </h1>
        <p className="text-center text-gray-600 mb-6 max-w-2xl mx-auto">
          We offer comprehensive consulting services to help your business achieve its goals 
          and reach new heights of success.
        </p>
        
        {/* Staff Recruitment Overview */}
        <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg p-8 mb-12 max-w-4xl mx-auto">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Staff Recruitment Services</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            We have a team of skilled recruiters and headhunters who source the right candidate by exploiting our private database, their personal network, multilevel networking and job portals.
          </p>
          <p className="text-gray-700 leading-relaxed mb-4">
            We cater recruitment solutions to various industries like Engineering, Automobile, Pharmaceutical, Food, Chemical, Civil, Glass, Paper, Polymer, BPO, ITES, Telecom, Banking, Hospitality, Healthcare, Medical, Secretary, Front Office, Data Entry, etc.
          </p>
          <div className="mt-6">
            <button 
              onClick={() => navigate('/services/staff-recruitment')}
              className="inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold transition duration-300"
            >
              Learn More About Our Recruitment Services
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md p-8 hover:shadow-lg transition-shadow duration-300" data-aos="fade-up" data-aos-delay={index * 150}>
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-3xl">{service.icon}</span>
                </div>
                <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                  {service.title}
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
              
              <div className="border-t pt-6">
                <h3 className="font-semibold text-gray-800 mb-3">What we offer:</h3>
                <ul className="space-y-2">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center text-gray-600">
                      <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="mt-6">
                <button 
                  onClick={() => navigate(service.path)}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition duration-300"
                >
                  Learn More
                </button>
              </div>
            </div>
          ))}
        </div>
        
        {/* Call to Action */}
        <div className="mt-16 bg-blue-600 rounded-lg p-8 text-center text-white">
          <h2 className="text-3xl font-bold mb-4">Ready to Get Started?</h2>
          <p className="text-xl mb-6 opacity-90">
            Let's discuss how we can help your business grow and succeed.
          </p>
          <button className="bg-white text-blue-600 hover:bg-gray-100 font-semibold py-3 px-8 rounded-lg transition duration-300">
            Contact Us Today
          </button>
        </div>
      </div>
    </div>
  );
};

export default Services;
